import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'
import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import PanoramaFishEye from 'material-ui/svg-icons/image/panorama-fish-eye'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import ProjectCombobox from 'components/ProjectCombobox'
import Dates from './Dates'
import Depends from './Depends'
import ManagerSelect from './ManagerSelect'
import AgentCombobox from 'components/AgentCombobox'
import RepairmanCombobox from 'components/RepairmanCombobox'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		task: doc(state, props.objectID)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: (props.colspan>1)?"scroll":"hidden"
				   , overflowX: "hidden"
				}}
			>
				<div style={{width: "100%", padding:"10px 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<div style={{clear:"both", width:"100%"}}>
						<Checkbox
							checkedIcon={<CheckCircle />}
							uncheckedIcon={<PanoramaFishEye />}
							iconStyle={{
								transform: "scale(1.2)"
							}}
							style={{
								width: "auto"
							  , position: "relative"
							  , left: "-1px"
							  , top: "2px"
							  , float: "left"
							  , display: "inline-block"
							}}
							checked={props.task.done}
							disabled={false}
							onCheck={(evt, val) => {
								props.STAGE({
									_id: props.objectID
								  , done: !props.task.done
								})
							}}
						/>
						<TextField
							hintText="Enter Task Name"
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							underlineStyle={{borderBottom: "0px solid"}}
							multiLine = {true}
							style={{
								width: "calc(100% - 60px)"
							  , marginTop: "-10px"
							  , height: "45px"
							  , float: "left"
							  , display: "inline-block"
							}}
							inputStyle={{
								fontSize: "18px"
							  , marginTop: "0px"
							  , fontWeight: "bold"
							}}
							className="task-content"
							// ref="taskContent"
							defaultValue={props.task.taskContent}
							key={props.task.taskContent}
							onBlur={(evt) =>
								props.STAGE({
									_id: props.objectID
								  , taskContent: evt.target.value
								})
							}
						/>
					</div>
					<div style={{clear:"both", width:"100%"}}>
						<ProjectCombobox objectID={props.objectID} />
					</div>
					<Checkbox
						label="URGENT"
						labelStyle={{
							color: "#fd9a41"
						  , fontSize: "16px"
						  , fontWeight: "bold"
						}}
						iconStyle={{
							fill: "#fd9a41"
						}}
						style={{
							marginLeft: "-1px"
						}}
						checked={props.task.urgent}
						onCheck={() =>
							props.STAGE({
								_id: props.objectID
							  , urgent: !props.task.urgent
							})
						}
					/>

					<ManagerSelect objectID={props.objectID}/>

					<div style={{height:"35px", overflow:"hidden"}}>
						<SelectField
							value={
								(props.task.taskType)?
									props.task.taskType
									: "Admin"
							}
							onChange={
								(evt, indx, string) => props.STAGE({
									_id: props.task._id
								  , taskType: string
								})
							}
							fullWidth={false}
							underlineStyle={{borderBottom: "0px solid"}}
							iconStyle={{
								top: "0px"
							  , right: "0px"
							}}
							style={{
								width: "293px"
							  , color: "#000000"
							  , clear: "both"
							  , marginTop: "-10px"
							  , padding: "0"
							}}
							labelStyle = {{
								textAlign: "left"
							  , color: "#000000"
							  , fontSize: "16px"
							}}
						>
							<MenuItem
								value="Admin"
								primaryText="Admin task"
							/>
							<MenuItem
								value="Repair"
								primaryText="Repair task"
							/>
							<MenuItem
								value="Agent"
								primaryText="Agent task"
							/>
						</SelectField>
					</div>

					{props.task.taskType?
						<div style={{width:"100%", clear:"both"}}>
								{props.task.taskType== 'Repair'?<RepairmanCombobox objectID={props.task._id}/>
								: props.task.taskType == 'Agent'?<AgentCombobox objectID={props.task._id}/>
								: null}
						</div>
						: null
					}

					<TextField style={{position: "relative", width: "calc(100% - 104px)"}}
						id="task-description"
						floatingLabelText="Description"
						hintStyle={{fontStyle: "italic", fontSize: "14px"}}
						fullWidth={false}
						style={{
							width: "calc(100% - 24px)"
						  , position: "relative"
						  , marginTop: "-15px"
						  , marginLeft: "0px"
						}}
						inputStyle={{
							fontSize: "16px"
						  , fontWeight: "bold"
						}}
						underlineStyle={{
							left: "1px"
						  , borderBottom: "0px solid #b0bec4"
						}}
						floatingLabelStyle={{
							fontWeight: "100",
							fontSize: "14px"
						}}
						defaultValue={props.task.description || ""}
						key={props.task.description}
						onBlur={(evt)=>{
							props.STAGE({_id: props.objectID, description: evt.target.value})
						}}
					/>
				</div>
				{/*<Dates objectID={props.objectID} />*/}
				<Depends objectID={props.objectID} projectID={props.task.projectID}/>
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/manager/taskForm/LeftSide.js